import React, {useState} from 'react';
import {FacetedFilterCheckbox} from "../Filters/FacetedFilterCheckbox";
import Tooltip from "../Tooltip";

const MobileFilterGroup = ({group, onFacetChange}) => {

    const [isOpen, setIsOpen] = useState(group.selectedOptions.length > 0);

    return (
        <li
            className="mobile-modal__filter-list-item"
        >
            <button
                className="mobile-modal__filter-title mobile-modal__filter-title--padding-bottom"
                role="faceted-search-item-group"
                onClick={(event) =>
                    setIsOpen(!isOpen)
                }
            >
                <span className="flex">
                    <span>{group.label}</span>
                    {group.description && <Tooltip inline={true} helpText={group.description}/>}
                </span>
                <span className={"faceted-search__group-header-dropdown-arrow" + (isOpen ? " faceted-search__group-header-dropdown-arrow--active" : "")}></span>
            </button>
            {isOpen && <ul className="mobile-modal__checkbox-list">
                {group.options &&
                    group.options.map(
                        (item, itemIndex) => (
                            <li
                                key={`${item.label}-${itemIndex}`}
                                className="faceted-search__item"
                                role="faceted-search-item"
                            >
                                <FacetedFilterCheckbox
                                    item={item}
                                    group={group}
                                    onFacetChange={onFacetChange}
                                />
                            </li>
                        )
                    )}
            </ul>}
        </li>
    );
};

export default MobileFilterGroup;
